module.exports = __webpack_public_path__ + "img/sbar.d8c65373.png";